<template>
  <div id="header" :class="{ 'header-above-mask': $store.state.withdrawTip }">
    <img id="back" src="../../assets/back_white.png" @click="back">
    <span style="flex: 1"></span>
    <p class="btn_login" @click="login" v-if="!this.$store.state.token"></p>
    <div class="btn_user" v-if="this.$store.state.token">
      <img src="@/assets/header_default.png"/>
      <p>{{ indexData ? indexData.data.code : '' }}</p>
    </div>

    <div id="info_cash">
      <img src="../../assets/coins.png">
      <p id="btn_amount">$ {{ indexData ? indexData.data.showBalance.toFixed(2) : '' }}</p>
      <div id="btn_withdraw_contain" @click="withdraw">
        <!-- 提现提示出现时，按钮周围高亮光圈 -->
        <div v-if="$store.state.withdrawTip" class="withdraw-btn-glow"></div>
        <p id="btn_withdraw"></p>
      </div>
    </div>
    <img id="btn_service" src="../../assets/servicers.png" @click="goServiceWeb">
  </div>
</template>
<script>

import http from '@/utils/http'
import { mapState } from 'vuex'
import bus from 'vue3-eventbus'
import { openWithdrawUs } from '@/utils/withdrawEntry'

export default {
  props: {
    indexData: Object
  },
  computed: {
    ...mapState(['pn', 'channel', 'pkg']),
    showBalance () {
      if (!this.$props.indexData) {
        return ''
      } else {
        const jsonObj = JSON.parse(this.$props.indexData)

        return jsonObj.data.showBalance.toFixed(2)
      }
    }
  },
  methods: {
    back () {
      window.parent.postMessage(JSON.stringify({
        action: 'close',
        data: {
          title: 'close',
          iframeId: 'share-iframe'
        }
      }), '*')
      if (window.jskit) {
        // window.jskit.finishPage();
      }
    },
    login () {
      this.$store.commit('showLogin', true)
    },
    goServiceWeb () {

      let customer = `${http.baseH5Url}/customer_nova.html?channel=` + this.channel;
      // let customer = `http://192.168.2.115:8080/customer.html?channel=` + this.channel;

      if(this.indexData) {
        customer = customer + `&uid=${this.indexData.uid}`
      }
      customer = customer + `&pn=${this.pn}&pkg=${this.pkg}`
      // if(window.jskit){
      //   window.jskit.startPortraitPage(customer)
      // }else{

        this.$router.push({
          path: '/web',
          query: { url: customer },
          param: { url: customer }
        })
      // }

    },
    showLevelDialog () {
      bus.emit('showLevelDialog', true)
    },
    withdraw () {
        // 走 SPA 内的 Vue 版提现页（原静态页 withdraw-us.html 保留未删）
        // this.$router.push('/withdraw-us')
      if(this.indexData.withdraw && this.indexData.withdraw.canWithdraw){
        if (!this.$store.state.token) {
          this.login()
          return
        }

        // 安卓优先另开竖屏 WebView，避免横屏 WebView 里键盘横屏、内容竖屏
        openWithdrawUs(this.$router)
      } else {
        this.showShareTips()
      }
      // if (window.matchMedia('(orientation: portrait)').matches) {
      //   window.location.href = http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token
      //   // query: { url: http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   // this.$router.push({
      //   //   path: '/web',
      //   //   query: { url: http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   //
      //   //   // query: { url: http.baseH5Url + '/withdraw-us?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   //   param:  { url: http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   // })
      // } else if (window.matchMedia('(orientation: landscape)').matches) {
      //   window.location.href = http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token
      //   // this.$router.push({
      //   //   path: '/web',
      //   //   query: { url: http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   //
      //   //   // query: { url: http.baseH5Url + '/withdraw-us?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   //   param:  { url: http.baseH5Url + '/withdraw/withdraw-us.html?pn=' + this.pn + '&channel=' + this.channel + '&pkg=' + this.pkg + '&token=' + this.$store.state.token },
      //   // })
      // }
    },
    dismissDialog () {
      this.$emit('task')
    },
    showShareTips () {
      // 点击提现未达标 → 弹「邀请」提示，引导去邀请（文案沿用后端 withdrawTipsEn）
      this.dismissDialog()
      this.$router.push('/main/earn_cash/0')
      this.$store.commit('shareTip', true)
      this.$store.commit('shareTipEn', this.indexData.withdraw.withdrawTipsEn)
    },
  }
}
</script>

<style scoped>



@media screen and (orientation: portrait) {
  #header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vh;
    height: 8.3rem;
    display: flex;
    align-content: center;
    justify-content: center;
    background-image: url("../../assets/bg_title_bar.png");
    background-size: cover;
  }
}

@media screen and (orientation: landscape) {
  #header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 8.3rem;
    display: flex;
    align-content: center;
    justify-content: center;
    background-image: url("../../assets/bg_title_bar.png");
    background-size: cover;
  }
}

/* 提现提示出现时，把顶栏抬到黑色遮罩(z-index:50)之上，
   让 Withdraw 按钮不被压暗、且可点击；遮罩仍压暗其余内容 */
#header.header-above-mask {
  z-index: 60;
}

#back {
  margin-left: 5rem;
}

#header > :first-child {
  width: 5.7rem;
  height: 5.1rem;
  align-self: center;
}

#btn_level_icon {
  width: 5.3rem;
  height: 5.3rem;
  align-self: center;
  margin-left: 3rem;
  margin-right: 2rem;
}
#btn_level_icon:active {
  opacity: 0.6;
}
#btn_service {
  width: 5.3rem;
  height: 5.3rem;
  align-self: center;
  margin-right: 3rem;
}

#btn_service:active {
  opacity: 0.6;
}

.btn_login {
  display: flex;
  justify-self: center;
  justify-content: center;
  align-self: center;
  height: 5.4rem;
  width: 22.6rem;
  background-image: url("../../assets/iv_signup.png");
  background-size: cover;
}

.btn_login:active {
  opacity: 0.6;
}

.btn_user {
  justify-self: center;
  align-content: center;
  justify-content: center;
  align-self: center;
  position: relative;


  align-self: center;
  height: 5.4rem;
  min-width: 23rem;
  width: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  background-image: url("@/assets/bg_withdraw.png");
  box-sizing: border-box;
  align-items: center;
}

.btn_user > img {
  width: 5.4rem;
  height: 5.4rem;
  align-self: center;
  left: -1rem;
  top: auto;
  position: absolute;
}

.btn_user > p {
  font-size: 2.5rem;
  color: white;
  align-self: center
}

#info_cash {
  margin: 0 1.25rem 0 5rem;
  align-self: center;
  height: 5.4rem;
  min-width: 23rem;
  width: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  background-image: url("@/assets/bg_withdraw.png");
  box-sizing: border-box;
  align-items: center;
}

#info_cash > :first-child {
  margin-left: -1rem;
  margin-right: 2rem;
  height: 5.7rem;
  width: 5.4rem;
  align-self: center;
}

#btn_amount {
  color: #FBEB6E;
  font-size: 2.2rem;
  line-height: 4.6rem;
  margin-right: 1.6rem;
  font-weight: bolder;

}

#btn_withdraw_contain {
  width: 15.8rem;
  height: 5rem;
  align-self: center;
  display: flex;
  align-content: center;
  justify-content: center;
  background-image: url("../../assets/iv_withdraw.png");
  background-position: right;
  background-size: cover;
  position: relative;
}

/* 提现按钮高亮光圈：切图 bg_light_withdraw_btn.png（205x93，比例 2.204）
   按比例设尺寸避免变形，略大于按钮环绕四周 */
.withdraw-btn-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 16.8rem;
  height: 7.62rem;
  background: url("@/assets/bg_light_withdraw_btn.png") center / 100% 100% no-repeat;
  pointer-events: none;
}

#btn_withdraw_contain:active {
  opacity: 0.6;
}

#btn_withdraw_contain > p {
  color: white;
  align-self: center;
  line-height: 4.6rem;
  font-weight: bolder;
  font-size: 2.2rem;
}

</style>
